const parseBoolean = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  return ['1', 'true', 'yes', 'on'].includes(String(value).trim().toLowerCase());
};

const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'local';
const nodeEnv = process.env.NODE_ENV || (appEnv === 'local' ? 'development' : 'production');
const isProduction = nodeEnv === 'production';

const apiBaseUrl = process.env.REACT_APP_MARKET_INTELLIGENCE_API_URL || 'http://localhost:5000/api';

const config = {
  appEnv,
  nodeEnv,
  apiBaseUrl,
  assistantApiUrl: `${apiBaseUrl}/assistant`,
  ragApiUrl: process.env.REACT_APP_RAG_API_URL || 'http://localhost:7000/api/v2',
  logLevel: process.env.REACT_APP_LOG_LEVEL || (isProduction ? 'warn' : 'debug'),
  enableApiLogs: parseBoolean(process.env.REACT_APP_ENABLE_API_LOGS, !isProduction),
  cryptoKey: process.env.REACT_APP_CRYPTO_KEY || '',
  enableSecurityHeaders: parseBoolean(process.env.REACT_APP_ENABLE_SECURITY_HEADERS, true),
  securityAccept: process.env.REACT_APP_SECURITY_ACCEPT || 'application/json',
  securityXRequestedWith: process.env.REACT_APP_SECURITY_X_REQUESTED_WITH || 'XMLHttpRequest',
  securityXClientApp: process.env.REACT_APP_SECURITY_X_CLIENT_APP || 'market-intelligence-ui',
  enableRequestIdHeader: parseBoolean(process.env.REACT_APP_ENABLE_REQUEST_ID_HEADER, true),
  enableAdVideoPlayback: parseBoolean(process.env.REACT_APP_MI_ENABLE_AD_VIDEO_PLAYBACK, false),
};

export default config;

export const {
  appEnv: APP_ENV,
  nodeEnv: NODE_ENV,
  apiBaseUrl: API_BASE_URL,
  assistantApiUrl: ASSISTANT_API_URL,
  ragApiUrl: RAG_API_URL,
  logLevel: UI_LOG_LEVEL,
  enableApiLogs: ENABLE_API_LOGS,
  cryptoKey: CRYPTO_KEY,
  enableSecurityHeaders: ENABLE_SECURITY_HEADERS,
  securityAccept: SECURITY_ACCEPT,
  securityXRequestedWith: SECURITY_X_REQUESTED_WITH,
  securityXClientApp: SECURITY_X_CLIENT_APP,
  enableRequestIdHeader: ENABLE_REQUEST_ID_HEADER,
  enableAdVideoPlayback: ENABLE_AD_VIDEO_PLAYBACK,
} = config;
